import { apiRequest, tokenStore } from '@/lib/apiClient';
import type { AuthResponse, User } from '@/types';

export async function login(username: string, password: string): Promise<AuthResponse> {
  const auth = await apiRequest<AuthResponse>('/api/auth/login', {
    method: 'POST',
    auth: false,
    body: { username: username.trim().toLowerCase(), password },
  });
  tokenStore.set(auth);
  return auth;
}

export function fetchMe(): Promise<User> {
  return apiRequest<User>('/api/auth/me');
}

export async function logout(): Promise<void> {
  try {
    await apiRequest<void>('/api/auth/logout', { method: 'POST' });
  } finally {
    tokenStore.clear();
  }
}

export function changePassword(currentPassword: string, newPassword: string): Promise<void> {
  return apiRequest<void>('/api/auth/change-password', {
    method: 'POST',
    body: { currentPassword, newPassword },
  });
}

export function requestRecovery(
  identificador: string,
  ultimosDigitosTelemovel?: string,
): Promise<{ mensagem: string }> {
  return apiRequest<{ mensagem: string }>('/api/auth/recuperar', {
    method: 'POST',
    auth: false,
    body: { identificador, ultimosDigitosTelemovel },
  });
}
